import React from "react";
import {useNavigate, useSearchParams} from "react-router-dom";
import {Button, Result} from "antd";

const PaymentStatus = () => {
  const navigate = useNavigate();
  // const params = new URLSearchParams(window.location.search);
  const [searchParams] = useSearchParams();
  const isPaymentSuccessful = searchParams.get('success');
  const success = isPaymentSuccessful === 'true';

  return (
    <div>
      <h2>Payment Status</h2>
      { success ?
      <Result
        status="success"
        title="Successfully Purchased Storage Booking!"
        extra={[
          <Button type="primary" className="yellow-btn" onClick={() => {
            navigate("/user/booking");
          }} key="console">
            Dashboard
          </Button>
        ]}
      />
        :
        <Result
          status="error"
          title="Payment Failed"
          extra={[
            <Button type="primary" className="yellow-btn" onClick={() => {
              navigate("/user");
            }} key="console">
              Dashboard
            </Button>
          ]}
        />
      }
    </div>
  );
};

export default PaymentStatus;
